'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _capeStyle = require('cape-style');

var _capeStyle2 = _interopRequireDefault(_capeStyle);

var _Link = require('../Link/Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = {
  links: (0, _capeStyle2.default)('bb block fs1 textReset')
};

function NavItem(_ref) {
  var className = _ref.className,
      isActive = _ref.isActive,
      id = _ref.id,
      props = _objectWithoutProperties(_ref, ['className', 'isActive', 'id']);

  return _react2.default.createElement(
    'li',
    { className: (0, _classnames2.default)(id, className, { active: isActive }) },
    _react2.default.createElement(_Link2.default, _extends({ style: styles.links }, props))
  );
}
NavItem.propTypes = {
  // action: PropTypes.func,
  className: _propTypes2.default.string,
  // icon: PropTypes.string,
  id: _propTypes2.default.string,
  isActive: _propTypes2.default.bool
  // label: PropTypes.string,
};
NavItem.defaultProps = {
  className: null,
  id: null,
  isActive: false
};
exports.default = NavItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Menu/NavItem.js
// module id = 695
// module chunks = 0